import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

function NewsTabs() {
    const feed = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

    return (
        <>
            <div className='container max-w-7xl mx-auto'>
                <div className="flex justify-center mt-10 gap-4">
                    {/* First Column */}
                    <ul className="flex flex-col items-center content-center text-center px-5 py-7 text-lg font-medium leading-5 whitespace-nowrap bg-white rounded-2xl border border-gray-300 border-solid shadow-sm max-w-[197px] text-neutral-900 h-fit *:cursor-pointer">
                        <li>اخبار الخير</li>
                        <li className="mt-7">قصص النجاح</li>
                        <li className="mt-7">تقارير انسانية</li>
                        <li className="justify-center self-stretch px-14 py-2 mt-5 font-bold text-white bg-blue-500 rounded-lg border border-blue-900 border-solid shadow-sm">
                            المدونة
                        </li>
                        <li className="self-stretch mt-5">الاسئلة الاكثر شيوعاً</li>
                    </ul>

                    {/* Second Column */}
                    <div className="w-full bg-white rounded-lg border-2">
                        <div className="grid grid-cols-1   lg:grid-cols-2 grid-rows-2 gap-4 p-5">
                            {feed.filter((item, index) => index < 4).map((filteredItem, index) => (
                                <div key={index} className="flex flex-row max-w-fill mx-auto bg-white border-2 rounded-lg overflow-hidden p-1 w-full h-[236px]">
                                    <LazyLoadImage className="object-cover h-full rounded-lg w-[220.75px]" src="https://s3-alpha-sig.figma.com/img/6f30/6128/cf00314f538faf1cf6205fff67ddf6e1?Expires=1710720000&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=DMBPEGrcI6W~lCAa0ubolNEz9phAF1BJzmZouIhBKOI4V5gkITO9896WyICg3W99T4b6Zzls9Gtrfw7N79bz2PSWZyrkvgZQFSOg9KPK6fCu3pe3qxLb~XuqcRbjw-BISMHlm~-up~m41amhW6YFJTWPJdJKtM5cXTrQTnEq6e3RcHDxRB0KFEmOdYkHorFIfS4UpCOYn54NHmaRTyyFzKGSCuvZCS8T4YWZofaNfvnBvBp91uRXqZwgEH2-73vym3vFKa52WbdltUUhas4E7fnVKMtynehKk9BE2--xrMfzecyQe0vifCBYq9ddxHzCEx5~p4NIyCgTP7mkzQCTAA__" alt="Placeholder" />
                                    <div className="flex flex-col items-start justify-evenly py-5 px-4">
                                        <span className="rounded-xl py-0 px-2.5 text-sm font-semibold bg-[#FFF3C7] border-[#926B0F] border-2">إغاثة</span>
                                        <h2 className="text-2xl font-bold">الناجون من فيضانات ليبيا محاصرون بين نقص المياه والألغام</h2>
                                        <span className="text-xs text-gray-500">18 April 2023</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className='flex items-center flex-col mb-5'>
                            <button className='border-2 border-gray-300 rounded-lg px-2 py-1'>عرض المزيد</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NewsTabs